import { Box, Button, Dialog, Typography, styled } from '@mui/material';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 16,
    backgroundColor: theme.palette.common.white,
  },
}));

export const DialogContainer = styled(Box)(() => ({
  minWidth: 600,
  minHeight: 200,
  padding: 40,
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
}));

export const TextTypography = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  fontSize: '24px',
  fontWeight: '600',
  margin: '0 0 20px',
  '& span': { color: theme.palette.secondary.main },
}));

export const ButtonBox = styled(Box)(() => ({
  margin: '20px 0',
  display: 'flex',
  gap: '40px',
  justifyContent: 'center',
}));

export const OutlinedButton = styled(Button)(({ theme }) => ({
  maxWidth: '150px',
  border: `1.5px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  backgroundColor: '#FAFCFF',
  textTransform: 'lowercase',
}));

export const FilledButton = styled(Button)(({ theme }) => ({
  maxWidth: '150px',
  backgroundColor: theme.palette.secondary.main,
  textTransform: 'lowercase',
  '&:hover': {
    filter: 'brightness(85%)',
  },
}));
